/**
 * Countries the platform is launched in.
 *
 * Lifted out of `pages/onboarding/index.tsx` so signup can collect the country
 * at account creation instead of leaving every organisation on the service
 * default and making onboarding step 2 exist purely to correct it
 * (_UI_improvements/tenant/auth-signup.md §4 item 2). `signup()` has always
 * accepted `countryIso`: the plumbing existed and was unused.
 */
export const COUNTRIES = [
  { value: 'ZA', labelKey: 'onboarding.steps.region.country.za' },
  { value: 'NG', labelKey: 'onboarding.steps.region.country.ng' },
  { value: 'KE', labelKey: 'onboarding.steps.region.country.ke' }
] as const;

export const DEFAULT_COUNTRY = 'ZA';
